import React, { useContext, useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link, useHistory } from "react-router-dom";
import { DataContext } from "../Context";

const SlideCard = () => {

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    appendDots: (dots) => {
      return <ul style={{ margin: "0px 0px 0px 0px" }}>{dots}</ul>;
    },
  };

  const { heroSliderCategorias, heroSlider, baseImage } = useContext(DataContext);
  const [idCategoria, setIdCategoria] = useState(0);
  const history = useHistory();


  const renderProduct = (categoria) => {
    heroSliderCategorias.map(value => {
      if (value.HeroSlider_id === categoria) {
        history.push(`/productview/${value.categorias_id}`);
        console.log("Id de categoria:", value.categorias_id)
      }
    })
  }

  const [matches, setMatches] = useState(
    window.matchMedia("(min-width: 768px)").matches
  )

  useEffect(() => {
    window
      .matchMedia("(min-width: 768px)")
      .addEventListener('change', e => setMatches(e.matches));
  }, []);
  return (
    <>
      <Slider {...settings}>
        {heroSlider.map((value, index) => {
          return (
            // create ondoubleclick evento only for mobile
            <div key={index} className="flex_slider_container">
              {!matches && (<img onClick={() => renderProduct(value.categoria[0])} key={value.id} src={baseImage + value.imagen} alt={value.imagen} />)}
              {matches && (<img onDoubleClick={() => renderProduct(value.categoria[0])} key={value.id} src={baseImage + value.imagen} alt={value.imagen} />)}

            </div>

          );
        })}
      </Slider>
    </>
  );
};

{/* <div key={index} className="flex_slider_container top">
<div className="left">
  <h1>{value.title}</h1>
  <p>{value.desc}</p>
  <Link to={"/armatupc"}>
    <button className="btn-primary">Mas Información</button>
  </Link>
</div>
<div className="right">
  <img src={value.cover} alt="" className="img-home" />
</div>
</div> */}

export default SlideCard;
